import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
} from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import moment from "moment";
import { isObject } from "lodash";
import { frxAppOptions, happeningTypeOptions, mallOptions } from "../../../common/constants";
import { CircularProgress } from "@material-ui/core";
import ReactQuill from "react-quill";
import { FaCloudUploadAlt } from "react-icons/fa";

const AddAppTopMenu = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [position, setPosition] = useState();
  const [title, setTitle] = useState();
  const [titleError, setTitleError] = useState(false);
  const [navigation, setNavigation] = useState({});
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [neverEnding, setNeverEnding] = useState(false);
  const [selectedFRXSection, setselectedFRXSection] = useState(frxAppOptions[frxAppOptions.length - 1]);
  const [externalUrl, setExternalUrl] = useState();
  const [externalUrlErrorMessage, setExternalUrlErrorMessage] = useState("");
  const [externaLinkName, setExternalLinkName] = useState("");
  const [publishDate, setPublishDate] = useState("");
  const [unPublishDate, setUnPublishDate] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loader, setLoader] = useState(false);
  const [customCheck, setcustomCheck] = useState(false);
  const [customNavigation, setCustomNavigation] = useState(JSON.stringify({ "section": "", "custom": true, "params": { "CampaignMedium": "AppTopMenu", "Link": "" } }));
  const [selectedMall, setSelectedMall] = useState(null);
  const [selectedHappeningType, setSelectedHappeningType] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
  }, []);

  const handleSubmit = () => {
    const link = document.getElementById("campaign_link_input")?.value ? document.getElementById("campaign_link_input")?.value : "";
    const article_id = document.getElementById("article_id")?.value;
    const titleFRX = document.getElementById("title_input_frx")?.value;
    if (!position) {
      setErrorMessage("Please enter position");
      setErrorAlert(true);
      return;
    } else if (!title) {
      setErrorMessage("Please enter title");
      setErrorAlert(true);
      return;
    } else if (title.length > 22) {
      setErrorMessage("Title must be 22 characters or fewer.");
      setErrorAlert(true);
      return;
    }

    if (selectedFRXSection.value == "NA") {
      if (!externalUrl) {
        setErrorMessage("Please Enter URL");
        setErrorAlert(true);
        return;
      } else if (externalUrlErrorMessage) {
        setErrorMessage("Please enter valid URL");
        setErrorAlert(true);
        return;
      } else if (!checkTextInsideHtml(externaLinkName)) {
        setErrorMessage("Please Enter Exit Message Description");
        setErrorAlert(true);
        return;
      }
    }

    if (selectedFiles.length < 1) {
      setErrorMessage("Please select icon image");
      setErrorAlert(true);
      return;
    } else if (publishDate == "Invalid date" || !publishDate) {
      setErrorMessage("Please select publish date");
      setErrorAlert(true);
      return;
    } else if (!neverEnding) {
      if (unPublishDate == "Invalid date" || !unPublishDate) {
        setErrorMessage("Please select unpublish date");
        setErrorAlert(true);
        return;
      } else if (unPublishDate < publishDate) {
        setErrorMessage("Unpublish date should be after the publish date");
        setErrorAlert(true);
        return;
      }
    } else if (customCheck) {
      if (!customNavigation) {
        setErrorMessage("Please Enter Navigation");
        setErrorAlert(true);
        return;
      }
    }

    if (selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck) {
      if (!link) {
        setErrorMessage("Please Enter campaign tracking name");
        setErrorAlert(true);
        return;
      }
    }
    setLoader(true);

    let _deeplinkObjFRX = {
      section: "",
      params: {},
    };
    if (selectedFRXSection) {
      _deeplinkObjFRX.section = selectedFRXSection?.value;
      _deeplinkObjFRX.params.CampaignMedium = "AppTopMenu";
      _deeplinkObjFRX.params.Link = link;

      if (selectedFRXSection.value == "ewallet") {
        _deeplinkObjFRX.params = selectedFRXSection.params;
      } else if (selectedFRXSection.value == "NA") {
        _deeplinkObjFRX = {};
        _deeplinkObjFRX.section = "NA";
        _deeplinkObjFRX.url = externalUrl;
        _deeplinkObjFRX.external_link_name = externaLinkName;
      } else if (selectedFRXSection.value == "UobUni") {
        _deeplinkObjFRX.section = "UobUni";
      } else if (selectedFRXSection.value == "ShowQR") {
        _deeplinkObjFRX.section = "ShowQR";
      } else if (selectedFRXSection?.value == "FRxMemberSpending") {
        _deeplinkObjFRX.login_required = true;
      } else if (selectedFRXSection.value == "digital_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params._params = "digital_gift_card_listing";
      } else if (selectedFRXSection.value == "add_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params.show_add_selection_modal = true;
      } else if (selectedFRXSection.value == "buy_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params.show_buy_selection_modal = true;
      } else if (selectedFRXSection.value == "ArticleDetail") {
        _deeplinkObjFRX.params.data = `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`;
        _deeplinkObjFRX.params.title = titleFRX;
        _deeplinkObjFRX.params.article = {
          category: titleFRX,
          id: `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`,
        };
      } else if (selectedFRXSection.value == "RewardsTab") {
        _deeplinkObjFRX.params.Link = link;
      } else if (selectedFRXSection.value == "No Navigation") {
        _deeplinkObjFRX = " ";
      } else if (selectedFRXSection.value == "BuyForMySelf") {
        _deeplinkObjFRX.params.buy_for = "me";
      }
    }

    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");

    var formdata = new FormData();
    formdata.append("sort_order", position);
    formdata.append("title", title);
    formdata.append("nav_to", customCheck ? customNavigation : JSON.stringify(_deeplinkObjFRX));
    formdata.append("icon_img", selectedFiles[0], selectedFiles[0].path);
    formdata.append("item_status", status);
    formdata.append("login_required", 0);
    formdata.append("publish_date", publishDate);
    formdata.append("unpublish_date", neverEnding ? "" : unPublishDate);
    formdata.append("created_datetime", currentDate);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/app-customization-top-menu`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 201) {
          setSuccesAlert(true);
          setLoader(false);
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const checkCharacterCount = (e, count) => {
    if (e.target.innerText.length > count && e.key !== "Backspace") {
      e.preventDefault();
    }
  };
  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };
  const handleExternalUrl = (value) => {
    setExternalUrl(value);
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if (value) {
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage("Please enter valid URL (Including https://)");
      } else {
        setExternalUrlErrorMessage("");
      }
    } else {
      setExternalUrlErrorMessage("");
    }
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/app-customisation/app-top-menu");
        }}
        onConfirm={() => {
          props?.history.push("/app-customisation/app-top-menu");
          setSuccesAlert(false);
          setLoader(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"App Top Menu Item Added Successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const validateFileSize = (file) => {
    let extension = file[0].path.split(".").pop().toLowerCase();
    if (extension !== "png" && extension !== "svg") {
      setErrorMessage("Please select a .png or .svg file");
      setErrorAlert(true);
      return;
    }
    if (extension === "svg") {
      // SVGs are scalable, so skip the fixed dimension check
      handleAcceptedFiles(file);
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      var image = new Image();
      image.src = e.target.result;
      image.onload = function () {
        var height = this.height;
        var width = this.width;

        if (width !== 95 || height !== 95) {
          setErrorMessage("Width and height must be 95px");
          setErrorAlert(true);
        } else {
          handleAcceptedFiles(file);
        }
      };
    };
  };
  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(files);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="App Customisation" breadcrumbItem="Add App Top Menu Item" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <input
                                type="number"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => {
                                  setPosition(e.target.value);
                                }}
                                defaultValue={position}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => {
                                  setTitle(e.target.value);
                                  setTitleError(e.target.value.length > 22);
                                }}
                                defaultValue={title}
                              />
                              {titleError && (
                                <p style={{ color: "red", fontSize: 12 }}>
                                  Maximum of 22 characters only
                                </p>
                              )}
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Form>
                                <Row>
                                  <Col lg={4} md={10} sm={10}>
                                    <div className="mb-3">
                                      <Label>Navigate To</Label>
                                      {customCheck ? 
                                        <textarea
                                        rows={4}
                                        col={20}
                                        type="text"
                                        className="form-control"
                                        id="item_group_input"
                                        onChange={(e) => {
                                          setCustomNavigation(e.target.value);
                                        }}
                                        defaultValue={customNavigation}
                                      />
                                      :<Select
                                        isSearchable={true}
                                        value={selectedFRXSection}
                                        onChange={(e) => {
                                          setselectedFRXSection(e);
                                        }}
                                        placeholder={
                                          selectedFRXSection?.label
                                            ? selectedFRXSection?.label
                                            : "Choose section..."
                                        }
                                        defaultValue={frxAppOptions[0]}
                                        options={frxAppOptions}
                                        maxMenuHeight={120}
                                        menuPlacement="auto"
                                        required
                                      />}
                                    </div>
                                  </Col>
                                  <Col md={1}></Col>
                                  <Col md={2} style={{paddingTop:"38px"}}>
                                  <div className="form-check form-switch">
                                    <input
                                      type="checkbox"
                                      className="form-check-input checkbox"
                                      id="checkbox_custom_nav"
                                      value={customCheck}
                                      defaultChecked={customCheck}
                                      onClick={() => { 
                                      setcustomCheck(!customCheck)
                                      }}
                                    />

                                    <label className="form-check-label" htmlFor="checkbox_pocuno">
                                      Custom Navigation
                                    </label>
                                  </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={4} md={6} sm={6}>
                                    {(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck) &&<div className="mb-3">
                                      <Label>Campaign Tracking Name</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={
                                          isObject(navigation) &&
                                          navigation?.params?.Link
                                        }
                                        id="campaign_link_input"
                                      />
                                    </div>}
                                  </Col>
                                </Row>
                                <Row>
                                { (selectedFRXSection?.label == "External Link" && !customCheck) &&
                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      <Label>URL*</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue=""
                                        id="external_url_input"
                                        onChange={(e) => {                                      
                                        handleExternalUrl(e.target.value)
                                      }}
                                      />
                                      {externalUrlErrorMessage && (
                                      <p style={{ color: "red", fontSize: 12 }}>
                                        {externalUrlErrorMessage}
                                      </p>
                                    )}
                                    </div>
                                  </Col>}
                                </Row>
                                <Row>
                                  {(selectedFRXSection?.label == "External Link" && !customCheck) &&
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>{"Exit Message Description*"}</Label>
                                        <ReactQuill
                                          modules={{
                                            toolbar: [
                                              ["bold", "italic", "underline"],
                                              [{ list: "ordered" }, { list: "bullet" }],
                                              ["link", { color: [] }],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          value={externaLinkName}
                                          onChange={(e, delta, source, c) => {
                                            if (c.getText().length <= 2000) {
                                              setExternalLinkName(e);
                                            } else if (c.getText().length > 2000) {
                                              const remainingCharacters = 2000 - c.getText().length;
                                              let truncatedText = c.getText().slice(0, remainingCharacters);
                                              setExternalLinkName(truncatedText)
                                            }
                                          }}
                                          onKeyDown={(e) => checkCharacterCount(e, 2000)}

                                          style={{ minHeight: "30px" }}
                                        />
                                      </div>
                                    </Col>}
                                  <Col md={1}></Col>
                                </Row>
                                {(selectedFRXSection?.value ==
                                  "ArticleDetail" && !customCheck) && (
                                  <>
                                    <Row className="mb-3">
                                      <Label
                                        className="col-sm-8 col-form-label"
                                        htmlFor="formrow-firstname-input"
                                      >
                                        Blog ID
                                      </Label>
                                      <div className="col-md-10">
                                        <input
                                          className="form-control"
                                          type="text"
                                          defaultValue={
                                            navigation?.params?.data
                                          }
                                          id="article_id"
                                        />
                                      </div>
                                    </Row>
                                    <Row className="mb-3">
                                      <Label
                                        className="col-sm-8 col-form-label"
                                        htmlFor="formrow-firstname-input"
                                      >
                                        Header Title
                                      </Label>
                                      <div className="col-md-10">
                                        <input
                                          className="form-control"
                                          type="text"
                                          defaultValue={
                                            isObject(navigation) &&
                                            navigation?.params?.title
                                          }
                                          id="title_input_frx"
                                        />
                                      </div>
                                    </Row>
                                  </>
                                )}
                                {(selectedFRXSection?.value == "ArticleDetail" && !customCheck) && (
                                  <>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Mall</Label>
                                          <Select
                                            isSearchable={true}
                                            onChange={(e) => {
                                              setSelectedMall(e);
                                              setSelectedHappeningType(null);
                                            }}
                                            options={mallOptions}
                                            placeholder="Select Mall..."
                                            value={selectedMall}
                                          />
                                        </div>
                                      </Col>
                                    </Row>

                                    {selectedMall && (
                                      <Row>
                                        <Col lg={4} md={6} sm={6}>
                                          <div className="mb-3">
                                            <Label>Type</Label>
                                            <Select
                                              isSearchable={true}
                                              onChange={(e) => {
                                                setSelectedHappeningType(e);
                                              }}
                                              options={happeningTypeOptions}
                                              placeholder="Select Happening Type..."
                                              value={selectedHappeningType}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    )}

                                    {selectedHappeningType && (
                                      <>
                                        <Row>
                                          <Col lg={4} md={6} sm={6}>
                                            <div className="mb-3">
                                              <Label>Blog ID</Label>
                                              <input
                                                className="form-control"
                                                type="text"
                                                defaultValue=""
                                                id="article_id"
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col lg={4} md={6} sm={6}>
                                            <div className="mb-3">
                                              <Label>Header Title</Label>
                                              <input
                                                className="form-control"
                                                type="text"
                                                defaultValue=""
                                                id="title_input_frx"
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      </>
                                    )}
                                  </>
                                )}
                              </Form>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <Card>
                              <CardBody>
                                <Form>
                                  <Label>Icon Image</Label>
                                  <Dropzone
                                    onDrop={(acceptedFiles) => {
                                      validateFileSize(acceptedFiles);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <FaCloudUploadAlt className="display-4 text-muted" />
                                          </div>
                                          <h4>
                                            Drop files here or click to upload.
                                          </h4>

                                          <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            Image should be 95X95px in png (SVG accepted - no dimension restrictions)
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {selectedFiles.map((f, i) => {
                                      return (
                                        <Card
                                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                          key={i + "-file"}
                                        >
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="80"
                                                  className="avatar-sm rounded bg-light"
                                                  alt={f.name}
                                                  src={f.preview}
                                                />
                                              </Col>
                                              <Col>
                                                <Link
                                                  to="#"
                                                  className="text-muted font-weight-bold"
                                                >
                                                  {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                  <strong>
                                                    {f.formattedSize}
                                                  </strong>
                                                </p>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      );
                                    })}
                                  </div>
                                </Form>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={publishDate}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setUnPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={unPublishDate}
                                  disabled={neverEnding}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col style={{ paddingTop: 35 }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="checkbox_1"
                                checked={neverEnding}
                                onChange={() => {
                                  setNeverEnding(!neverEnding);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkbox_1"
                              >
                                Never-ending
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/app-customisation/app-top-menu");
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                        disabled={loader}
                        style={{ color: "#ffffff", width: "80px", marginLeft: "10px" }}
                        className={"btn btn-success"}
                        onClick={() => {
                          handleSubmit();
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? (
                          <CircularProgress size={15} value={100} color={"white"} />
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddAppTopMenu;
